import * as React from "react";
import { connect } from "react-redux";
import { Route, Redirect, Switch } from "react-router-dom";
import Helmet from "react-helmet";
import * as routes from "../../utils/routes";
import { getLinkTo } from "../../utils/routes/navigate";
import { ConnectedMonitoring as MonitoringScene } from "./Monitoring";
import { InsightsScene } from "./Insights";
import InsightEquipsScene from "./InsightEquips";
import MonitoringEquipsScene from "./MonitoringEquips";

interface ConnectedProps {
  appReady: boolean;
}

type Props = ConnectedProps;

const mapStateToProps = (state: Insite.AppState): ConnectedProps => ({
  appReady: state.appSetup.appSetupComplete,
});

const Analysis: React.FunctionComponent<Props> = ({ appReady }) => {
  if (!appReady) {
    return null;
  }

  return (
    <>
      <Helmet title="Analysis" />

      {/* Routing insights */}
      <Switch>
        <Redirect
          exact
          from={routes.ANALYSIS}
          to={getLinkTo(routes.INSIGHTS)}
        />
        <Route exact path={routes.INSIGHTS} component={InsightsScene} />
        <Route
          exact
          path={routes.INSIGHT_EQUIPS}
          component={InsightEquipsScene}
        />
      </Switch>

      {/* Routing monitoring */}
      <Switch>
        <Route exact path={routes.MONITORING} component={MonitoringScene} />
        <Route
          exact
          path={routes.MONITORING_EQUIPS}
          component={MonitoringEquipsScene}
        />
      </Switch>
    </>
  );
};

export const AnalysisScene = connect(mapStateToProps)(Analysis);
